module.exports = __webpack_public_path__ + "img/chip_500.76e9fe27.png";